'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagUyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 0H28C28 6 28 20 28 20C28 20 27.1046 20 26 20H2.00003C0.89546 20 2.85506e-05 20 2.85506e-05 20C2.85506e-05 20 0.000191309 6 0 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M28 2.66667H13.3334V5.33333H28V2.66667Z", fill: "#0E4DC5" }),
      /* @__PURE__ */ jsx("path", { d: "M13.3334 8V10.6667H28V8H13.3334Z", fill: "#0E4DC5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.85506e-05 13.3333V16H28V13.3333L2.85506e-05 13.3333Z",
          fill: "#0E4DC5"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M2.85506e-05 20V18.6667H28V20H2.85506e-05Z", fill: "#0E4DC5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.66669 6.66667C8.66669 7.77124 7.77127 8.66667 6.6667 8.66667C5.56213 8.66667 4.6667 7.77124 4.6667 6.66667C4.6667 5.5621 5.56213 4.66667 6.6667 4.66667C7.77127 4.66667 8.66669 5.5621 8.66669 6.66667Z",
          fill: "#FED443"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.6667 9.3213L5.77661 10.65L5.55115 9.06669L4.17274 9.87757L4.65656 8.35327L3.06282 8.48577L4.1601 7.32236L2.6667 6.75024L4.1601 6.17813L3.06282 5.01471L4.65656 5.14721L4.17274 3.62291L5.55115 4.43379L5.77661 2.85053L6.6667 4.17918L7.55678 2.85053L7.78224 4.43379L9.16065 3.62291L8.67683 5.14721L10.2706 5.01471L9.17329 6.17813L10.6667 6.75024L9.17329 7.32236L10.2706 8.48577L8.67683 8.35327L9.16065 9.87757L7.78224 9.06669L7.55678 10.65L6.6667 9.3213ZM6.6667 9.29569C8.07251 9.29569 9.21215 8.15606 9.21215 6.75024C9.21215 5.34442 8.07251 4.20479 6.6667 4.20479C5.26088 4.20479 4.12124 5.34442 4.12124 6.75024C4.12124 8.15606 5.26088 9.29569 6.6667 9.29569Z",
          fill: "#FED443"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 0H28L28 0.5H0.47821L0 0Z", fill: "#949494" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.85506e-05 13.332L0 0L0.47821 0.5L0.500029 13.332H2.85506e-05Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagUyAsset = forwardRef(FlagUyAsset);

export { VpFlagUyAsset as default };
